/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./sentry');
require('./polyfills');
require('./onLoad');
require('./cookie-policy');
require('./common');
require('./s2s');
require('./common/intersect-media');

require('./diet');

require('./braintree-drop-in-v1');
